// extracted by mini-css-extract-plugin
module.exports = {"root":"header-wrapper_root__lAW6v","withBorder":"header-wrapper_withBorder__KQ8VR"};